import { useCallback } from 'react';

import { ISection } from '@rbi-ctg/menu';
import { useMainMenuContext } from 'state/menu/main-menu';
import { DAY_PART_SELECTIONS } from 'state/menu/main-menu/types';
import { useStoreContext } from 'state/store';
import { IMenuObjectWithDaypart } from 'utils/availability';
import {
  getMenuItemDayParts,
  isAvailableForActiveDayParts,
} from 'utils/availability/daypart-availability';
import { findBurgersForBreakfastDayPart } from 'utils/daypart';

export const useFilterSectionOptionsByDayPart = () => {
  const { activeDayParts, dayParts } = useMainMenuContext();
  const { store } = useStoreContext();
  const hasBurgersForBreakfast = store?.hasBurgersForBreakfast;

  return useCallback(
    (menuSection: Partial<ISection> | null) => {
      if (!menuSection?.options?.length || !dayParts?.length) {
        return menuSection;
      }

      return {
        ...menuSection,
        options: menuSection.options.filter(menuObject => {
          const menuObjectDayParts = getMenuItemDayParts(menuObject as IMenuObjectWithDaypart);
          const burgersForBreakfastDayPart = findBurgersForBreakfastDayPart(activeDayParts);

          // Burgers for Breakfast
          if (
            burgersForBreakfastDayPart &&
            menuObjectDayParts.includes(DAY_PART_SELECTIONS.BURGERS_FOR_BREAKFAST.toLowerCase())
          ) {
            return !!hasBurgersForBreakfast;
          }
          // Regular
          return isAvailableForActiveDayParts({
            activeDayParts,
            menuData: menuObject as IMenuObjectWithDaypart,
          });
        }),
      };
    },
    [activeDayParts, dayParts?.length, hasBurgersForBreakfast]
  );
};
